import React from  'react'

export default function Footer(){ 
  return(
    <div className='footer'>
        <p>Site Fictício para desafio Front-End da Confere.</p>
        <p>Feito por &copy;Hugo Bascuñan - 2021</p> 
    </div>
  )
}

// RODAPÉ